import api from "../../http";

export default class ApiIndexMainGame {
  static async getApiIndexMainGame(url) {
    return api.get(url)
  }
}